import React from 'react';
import { ClipboardCheckIcon, BookOpenIcon, ShieldCheckIcon, WifiIcon, KeyRoundIcon, SmartphoneIcon, ShieldIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function IntroAssessmentPage() {
  return <div className="w-full min-h-screen bg-white flex flex-col" data-id="element-1589">
      {/* Header with logo */}
      <header className="w-full bg-[#1a0647] px-6 py-4" data-id="element-1590">
        <div className="max-w-4xl mx-auto flex items-center" data-id="element-1591">
          <Link to="/" className="flex-shrink-0" data-id="element-1592">
            <img src="https://cdn.magicpatterns.com/uploads/ddFjEWvaDfXw4mBqdFC5Gd/Caveo_Logotype_Horizontal_240x50_White_PNG.png" alt="Caveo" className="h-5" data-id="element-1593" />
          </Link>
        </div>
      </header>

      {/* Main content */}
      <div className="px-6 pt-6 pb-10" data-id="element-1594">
        <div className="max-w-3xl mx-auto flex flex-col items-center text-center" data-id="element-1595">
          {/* Heading */}
          <h1 className="text-3xl md:text-4xl font-bold text-[#111111] mb-1 tracking-tight" data-id="element-1596">
            Digital Risk Assessment
          </h1>
          <p className="text-gray-500 text-base md:text-lg mb-6" data-id="element-1597">
            Get a personalized plan in 3-4 minutes.
          </p>

          {/* Three-step process */}
          <div className="flex items-center justify-center mb-6" data-id="element-1598">
            <div className="flex flex-col items-center" data-id="element-1599">
              <div className="w-14 h-14 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1600">
                <ClipboardCheckIcon size={24} className="text-gray-400" data-id="element-1601" />
              </div>
              <span className="mt-2 text-sm font-semibold text-[#111111]" data-id="element-1602">
                Assess
              </span>
            </div>

            <div className="w-10 md:w-16 h-[2px] bg-gray-200 mb-5" data-id="element-1603" />

            <div className="flex flex-col items-center" data-id="element-1604">
              <div className="w-14 h-14 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1605">
                <BookOpenIcon size={24} className="text-gray-400" data-id="element-1606" />
              </div>
              <span className="mt-2 text-sm font-semibold text-[#111111]" data-id="element-1607">
                Inform
              </span>
            </div>

            <div className="w-10 md:w-16 h-[2px] bg-gray-200 mb-5" data-id="element-1608" />

            <div className="flex flex-col items-center" data-id="element-1609">
              <div className="w-14 h-14 rounded-full border-2 border-gray-200 flex items-center justify-center bg-white" data-id="element-1610">
                <ShieldCheckIcon size={24} className="text-gray-400" data-id="element-1611" />
              </div>
              <span className="mt-2 text-sm font-semibold text-[#111111]" data-id="element-1612">
                Secure
              </span>
            </div>
          </div>

          {/* What's Covered */}
          <h2 className="text-base font-semibold text-[#631bb7] mb-3" data-id="element-1613">
            What's Covered
          </h2>

          <div className="flex justify-center w-full mb-6" data-id="element-1614">
            <div className="flex flex-col gap-2 items-start" data-id="element-1615">
              <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1616">
                <span className="text-xl flex-shrink-0" data-id="element-1617">🏠</span>
                <span className="ml-3 text-sm font-semibold text-[#111111] whitespace-nowrap" data-id="element-1618">
                  Home WiFi & Network
                </span>
              </div>
              <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1619">
                <span className="text-xl flex-shrink-0" data-id="element-1620">🔐</span>
                <span className="ml-3 text-sm font-semibold text-[#111111] whitespace-nowrap" data-id="element-1621">
                  Passwords & Accounts
                </span>
              </div>
              <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1622">
                <span className="text-xl flex-shrink-0" data-id="element-1623">📱</span>
                <span className="ml-3 text-sm font-semibold text-[#111111] whitespace-nowrap" data-id="element-1624">
                  Devices & Apps
                </span>
              </div>
              <div className="flex items-center px-4 py-2.5 bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1625">
                <span className="text-xl flex-shrink-0" data-id="element-1626">🛡️</span>
                <span className="ml-3 text-sm font-semibold text-[#111111] whitespace-nowrap" data-id="element-1627">
                  Privacy & Data Protection
                </span>
              </div>
            </div>
          </div>

          {/* Get Started button */}
          <Link to="/assessment" className="bg-[#631bb7] text-white px-6 py-2.5 rounded-lg font-bold text-lg no-underline hover:bg-[#521099] transition-all shadow-md" data-id="element-1628">
            Get Started
          </Link>
        </div>
      </div>
    </div>;
}